<template>
  <el-card shadow="never" class="aui-card--fill">
    <StoreList productType="原料" ref="storeList">
      <template slot="btns">
        <el-button type="primary" size="mini" @click="goChange(1)"
        >原料入库</el-button
        >
        <el-button type="primary" size="mini" @click="goChange(-1)"
        >原料出库</el-button
        >
        <el-button type="warning" size="mini" @click="$refs.commonUpload.init()"
        >入库数据导入</el-button
        >
        <el-button type="warning" size="mini" @click="$refs.receiptUpload.init()"
        >发票导入</el-button
        >
      </template>
    </StoreList>
    <common-upload
        ref="commonUpload"
        @success="uploadSuccessHandler"
        uploadUrl="/store/import/material"
        templateUrl="/static/template/采购入库导入模板.xlsx"
        title="入库数据导入"
    ></common-upload>
    <common-upload
        ref="receiptUpload"
        @success="uploadSuccessHandler"
        uploadUrl="/store/import/material"
        templateUrl="/static/template/采购入库导入模板.xlsx"
        title="入库数据导入"
    ></common-upload>
    <StoreLog ref="storeLog" @refreshDataList="getDataList"></StoreLog>
  </el-card>
</template>

<script>
import StoreLog from "../store-log/save";
import StoreList from "../common/index";
export default {
  components: {
    StoreList,
    StoreLog,
  },
  methods: {
    uploadSuccessHandler (e) {
      this.$refs.storeList.reload()
    },
    getDataList() {
      this.$refs.storeList.getDataList();
    },
    goChange(type) {
      this.$router.push(`/store/material/change?type=${type}`)
    },
  },
};
</script>
